angular.module("app").factory("settingsService", [
    'preLoadedData',
    'stateAliases',
    '$rootScope',
    function (preLoadedData, stateAliases, $rootScope) {
        var info = {},
            filtersData = {};

        if (!!preLoadedData.data && preLoadedData.data.status == "ok") {
            setSettings(preLoadedData.data);
        }

        function  setSettings (settings) {
            var allSettings = angular.copy(settings);
            var permissions = angular.copy(allSettings.userInfo.permissions);
            delete allSettings.userInfo;
            info.settings = angular.copy(allSettings);
            info.settings.menuVisibleStates = permissions;
            info.settings.menuVisibleStates && stateAliases.setStates(info.settings.menuVisibleStates, registerState);
            if (info.settings.allowedStates === undefined) {
                info.settings.allowedStates = [];
                info.settings.allowedStates.push('main.empty');
                info.settings.menuVisibleStates.push('empty');
            }
        }



        function getSettings () {
            return info.settings;
        }

        function reset () {
            if (!!info.settings) {
                for (var prop in info.settings) {
                    info.settings[prop] = undefined;
                }
            }
        }

        function registerState (state) {
            if (info.settings) {
                info.settings.allowedStates = info.settings.allowedStates || [];
                info.settings.allowedStates.push(state)
            }
        }

        function getAllowedStates () {
            if (info.settings && info.settings.allowedStates) {
                return info.settings.allowedStates;
            }
        }

        function getPreferredState () {
            return function (state) {
                var allowedStates = getAllowedStates();
                if (allowedStates && allowedStates.length) {
                    if (allowedStates.indexOf(state) != -1) {
                        return state
                    } else {
                        return allowedStates[0]
                    }
                }
            }
        }

        var ctx = {
            setSettings: setSettings,
            getSettings: getSettings,
            registerState: registerState,
            getPreferredState: getPreferredState,
            getFilters: function () {
                return filtersData
            },
            setFilters: function (filters) {
                filtersData = angular.extend({}, filters);
            },
            getAllowedStates: getAllowedStates,
            reset: reset
        };

        $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
            if (toState.stateRef != fromState.stateRef) {
                ctx.setFilters({})
            }
        });

        return ctx
    }
]);